import { put } from 'redux-saga/effects';

import { InsighttNotification } from '../../helpers/insightt-notification';
import HumanResourcesActions from '../actions/humanresources.actions';

export function* getUsersRequest(api) {
  const response = yield api.getUsers();
  if (response && response.ok) {
    yield put(HumanResourcesActions.getUsersSuccess(response.data));
  } else {
    yield put(HumanResourcesActions.getUsersFailure());
  }
}

export function* getUsersInfractionsRequest(api, action) {
  const { userId, startDate, endDate, timeZone, page } = action;
  const response = yield api.getUsersInfractions(userId, startDate, endDate, timeZone, page);
  if (response && response.ok) {
    yield put(HumanResourcesActions.getUsersInfractionsSuccess(response.data));
  } else {
    yield put(HumanResourcesActions.getUsersInfractionsFailure());
  }
}

export function* getUsersActivitiesRequest(api, action) {
  const { userId, dateStart, dateEnd, timezoneOffset, page, limit } = action;
  const response = yield api.getUsersActivities(userId, dateStart, dateEnd, timezoneOffset, page, limit);
  if (response && response.ok) {
    yield put(HumanResourcesActions.getUsersActivitiesSuccess(response.data));
  } else {
    yield put(HumanResourcesActions.getUsersActivitiesFailure());
  }
}

export function* getUsersTaskHistoryRequest(api, action) {
  const { userId, dateStart, dateEnd, timezoneOffset, page, limit } = action;
  const response = yield api.getUsersTaskHistory(userId, dateStart, dateEnd, timezoneOffset, page, limit);
  if (response && response.ok) {
    yield put(HumanResourcesActions.getUsersTaskHistorySuccess(response.data));
  } else {
    yield put(HumanResourcesActions.getUsersTaskHistoryFailure());
  }
}

export function* getUsersCommissionHistoryRequest(api, action) {
  const { userId, dateStart, dateEnd, timezoneOffset, page, limit } = action;
  const response = yield api.getUsersCommissionHistory(userId, dateStart, dateEnd, timezoneOffset, page, limit);
  if (response && response.ok) {
    yield put(HumanResourcesActions.getUsersCommissionHistorySuccess(response.data));
  } else {
    yield put(HumanResourcesActions.getUsersCommissionHistoryFailure());
  }
}

export function* getUsersActivityOverviewByIdRequest(api, action) {
  const {
    userId,
    dateStart,
    dateEnd,
    previousStartDate,
    previousEndDate,
    timezoneOffset: { timezoneOffset, type },
  } = action;
  const response = yield api.getUsersActivityOverviewById(
    userId,
    dateStart,
    dateEnd,
    previousStartDate,
    previousEndDate,
    timezoneOffset,
    type,
  );
  if (response && response.ok) {
    yield put(HumanResourcesActions.getUsersActivityOverviewByIdSuccess(response.data));
  } else {
    yield put(HumanResourcesActions.getUsersActivityOverviewByIdFailure());
  }
}

export function* getUsersByBranchRequest(api) {
  const response = yield api.getUsersByBranch();
  if (response && response.ok) {
    yield put(HumanResourcesActions.getUsersByBranchSuccess(response.data));
  } else {
    yield put(HumanResourcesActions.getUsersByBranchFailure());
  }
}

export function* getUsersActivityPageRequest(api) {
  const response = yield api.getUsersActivityPage();
  if (response && response.ok) {
    yield put(HumanResourcesActions.getUsersActivityPageSuccess(response.data));
  } else {
    yield put(HumanResourcesActions.getUsersActivityPageFailure());
  }
}

export function* getOverallUserActivityRequest(api, action) {
  const { pageNo, userId, activityType } = action;

  const response = yield api.getOverallUserActivity(pageNo, userId, activityType);
  if (response && response.ok) {
    yield put(HumanResourcesActions.getOverallUserActivitySuccess(response.data));
  } else {
    yield put(HumanResourcesActions.getOverallUserActivityFailure());
  }
}

export function* employeeFileListRequest(api, action) {
  const { userId } = action;
  const response = yield api.employeeFileList(userId);
  if (response && response.ok) {
    yield put(HumanResourcesActions.employeeFileListSuccess(response.data));
  } else {
    yield put(HumanResourcesActions.employeeFileListFailure(userId));
    InsighttNotification('error', 'There are some issues to fetch employee files', response);
  }
}

export function* uploadEmpFileRequest(api, action) {
  const { userId, title, file } = action;
  const formdata = new FormData();
  formdata.append('file', file);
  formdata.append('title', title);
  formdata.append('type', file.type);
  const response = yield api.uploadEmpFile(userId, formdata);
  if (response && response.ok) {
    const employeeList = yield api.employeeFileList(userId);
    yield put(HumanResourcesActions.uploadEmpFileSuccess(employeeList.data));
    InsighttNotification('success', 'Successfully Uploaded File!', response);
  } else {
    yield put(HumanResourcesActions.uploadEmpFileFailure(userId));
    InsighttNotification('error', 'There are some issues to fetch employee files', response);
  }
}
